import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { first } from 'rxjs/operators';

import { Keyword, User } from '../../../_models';
import { KeywordService, AuthenticationService, NotificationService, SpiderService, EnvService, UserService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-keyword-detail',
  templateUrl: './keyword-detail.component.html',
  styleUrls: []
})
export class KeywordDetailComponent implements OnInit {

  keyword: any = null; //Keyword
  loaded = false;
  loading = true;
  processing = false;
  //env
  countryList: any = [];
  intervalList = {};
  operatorList: any = [];
  clientList: any = [];
  spiderAccountList: any = [];
  allSpiderAccountList: any = null;
  reminderPeriodList: any = [];
  affiliateSelectionDisabled = false;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private userSvc: UserService,
    private envSvc: EnvService,
    private keywordSvc: KeywordService,
    private spiderSvc: SpiderService,
    private notification: NotificationService,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    let id = this.route.snapshot.paramMap.get('id');
    this.loadDetail(id);
    this.loadClients();
    this.loadSpiderAccount();
    this.loadCountryies();
    this.laodIntervalModes();
    this.loadReminderPeriods();
  }


  save() {
    this.processing = true;
    if (confirm("Are you sure to update this keyword?")) {
      this.keywordSvc.updateKeyword(this.keyword).subscribe(data => {
        if (data !== null) {
          if (data.status == 1) {
            this.notification.showSuccess("Keyword updated successfully!", "Update Keyword");
            this.modalService.dismissAll();
          } else {
            this.notification.showError(data.msg, "Fail update");
          }

        } else {
          this.notification.showError("Failed to update keyword, please try again later.", "Fail update");
        }
      });
      this.processing = false;
    } else {
      this.processing = false;
    }
  }

  back() {
    this.router.navigate(['/dashboard/keyword', {source: this.keyword.source, country: this.keyword.country, shortCode: this.keyword.shortCode, keyword: this.keyword.keyword, operator: this.keyword.operator}]);
  }

  private loadDetail(id){
    this.keywordSvc.getKeyword(id).subscribe(data => {
      this.keyword = data;
      this.affiliateSelectionDisabled = this.keyword.affiliateEnabled;
      this.loaded = true;
      this.loading = false;
      if(this.keyword != null && this.allSpiderAccountList != null){
         this.spiderAccountList = this.allSpiderAccountList.filter(it => it.source == this.keyword.source);
      }
    });
  }

  private loadClients() {
    this.userSvc.getAllClients().pipe(first()).subscribe(data => {
      this.clientList = data.data;
    });
  }

  private loadSpiderAccount() {
    this.spiderSvc.getAllSpiderAccount().pipe(first()).subscribe(data => {
      this.allSpiderAccountList = data.data;
      if(this.keyword != null){
        this.spiderAccountList = this.allSpiderAccountList.filter(it => it.source == this.keyword.source);
      }
    });
  }

  private loadCountryies(){
    this.envSvc.getCountries().pipe(first()).subscribe(data => {
      this.countryList = data.data;

    });
  }

  private laodIntervalModes(){
    this.envSvc.getIntervalModes().pipe(first()).subscribe(data => {
      this.intervalList = data.data;
    });
  }

  private loadReminderPeriods(){
    this.reminderPeriodList = this.envSvc.getReminderPeriods();
  }
}
